var moment = require('moment');
var module = angular.module('octopusApp.dashboard');

module.controller('DashboardController', function ($scope, $timeout, busy, pollLoop, octopusRepository, $window, $q){
  var isLoading = $scope.isLoading = busy.create();
  var loop = pollLoop.create($scope, function () { return refresh(); });
  var hardRefreshAt = moment().add(5, 'hours');
  $scope.projectLimit = 50;
  $scope.defaultProjectLimit = 50;
  $scope.dashboardLoaded = false;

  var refresh = function() {
    if (moment() > hardRefreshAt) {
      $window.location.reload();
      loop.stop();
      return $q.defer().promise; // Never resolved
    }
    return isLoading.promise(octopusRepository.Dashboards.getDashboard({highestLatestVersionPerProjectAndEnvironment: true}).then(function(dashboardData) {
      $scope.fullDashboardData = dashboardData;
      $scope.projectCount = $scope.fullDashboardData.Projects.length;
      $scope.projectLimit = $scope.fullDashboardData.ProjectLimit ? $scope.fullDashboardData.ProjectLimit : $scope.defaultProjectLimit;
      applyFilterAndLimit();
      $scope.projectGroups = _.sortBy($scope.fullDashboardData.ProjectGroups, function(group) {
        return group.Name.toLowerCase();
      });
      $scope.dashboardLoaded = true;
    }));
  };

  var applyFilterAndLimit = function()
  {
    if(!$scope.fullDashboardData) {
      return;
    }

    var data = _.clone($scope.fullDashboardData);

    var isOverLimit = function(d) { return d.Projects.length > $scope.projectLimit; };
    $scope.useFilter = isOverLimit(data);

    if(isOverLimit(data)) {
      applyFilter(data);

      if (isOverLimit(data)) {
        limitProjects(data);
      }

      removeGroupsWithoutProjects(data);
    }

    $scope.dashboardData = data;
  };

  var applyFilter = function(data) {
    if($scope.projectFilter)
    {
      data.Projects = data.Projects.filter(function(p) { return p.Name.toLocaleUpperCase().indexOf($scope.projectFilter.toLocaleUpperCase()) > -1; });
    }
    if($scope.groupFilter)
    {
      data.Projects = data.Projects.filter(function(p) { return p.ProjectGroupId === $scope.groupFilter; });
    }

    $scope.matchCount = data.Projects.length;
  };

  var limitProjects = function(data) {
    $scope.limited = true;
    var included = _.take(data.Projects, $scope.projectLimit);

    var erroredOrRunning = data.Items.filter(function(p) { return p.HasWarningsOrErrors || !p.IsCompleted; });

    var keep = _.chain(data.Projects)
      .rest($scope.projectLimit)
      .filter(function(p) {
        return _.any(erroredOrRunning, function(e) { return (e.ProjectId === p.Id); });
      })
      .value();

    data.Projects = included.concat(keep);
  };

  var removeGroupsWithoutProjects = function(data) {
    var groupIds = data.Projects.map(function(p) { return p.ProjectGroupId; });
    data.ProjectGroups = _.filter(data.ProjectGroups, function(g) { return _.contains(groupIds, g.Id); });
  };

  function init() {
      $scope.$watch('projectFilter', function() { applyFilterAndLimit(); });
      $scope.$watch('groupFilter', function() { applyFilterAndLimit(); });

      loop.startImmediately();
  }

    init();
});







//////////////////
// WEBPACK FOOTER
// ./app/areas/dashboard/controllers/dashboard_controller.js
// module id = 835770021825276
// module chunks = 1